import React from 'react';
import ChatBubble from 'core/icons/ChatBubble';
import styled from 'styled-components';
import { getColor, round } from 'core/utils';

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	border-radius: 4px;
	padding: 12px;
	background: ${getColor("concreteGray")};
	color: ${getColor("gray5")};
	font-size: 14px;
	line-height: ${round(18/14)};
	margin-bottom: 16px;

	svg {
		margin-right: 12px;
	}

	p {
		margin: 0;
	}
`;

const NoAnswers = () => (
	<Wrapper>
		<ChatBubble />
		<p>No answers yet! <em>Be the first to help by adding an answer below.</em></p>
	</Wrapper>
);

export default NoAnswers;
